<template>
<div class="chapter">
<div class="inner_page">
<div class="toc">
<a id="title14"><h1 class="title">Table of Contents</h1>
</a><div class="toc_entry"><a id="title14"><br/>
</a><span class="toc_entry_titlePage" href="#/e9781439636602_tp01" title="Link target outside of Sample"><span>Title Page</span></span><br/>
<span class="toc_entry_pubInfo" href="#/e9781439636602_cop01" title="Link target outside of Sample"><span>Copyright Page</span></span><br/>
<span class="toc_entry_dedicationPage" href="#/e9781439636602_ded01" title="Link target outside of Sample"><span>Dedication</span></span><br/>
<a class="toc_entry_acknowPage" href="#/e9781439636602_ack01"><span>ACKNOWLEDGMENTS</span></a><br/>
<a class="toc_entry_frontMatter" href="#/e9781439636602_fm02"><span>INTRODUCTION</span></a><br/>
<span class="toc_entry_chapter" href="#/e9781439636602_c01" title="Link target outside of Sample"><span>1 - THE CITY GAME</span></span><br/>
<span class="toc_entry_chapter" href="#/e9781439636602_c02" title="Link target outside of Sample"><span>2 - OAKLAND COUNTY</span></span><br/>
<span class="toc_entry_chapter" href="#/e9781439636602_c03" title="Link target outside of Sample"><span>3 - WAYNE COUNTY</span></span><br/>
<span class="toc_entry_chapter" href="#/e9781439636602_c04" title="Link target outside of Sample"><span>4 - THE CATHOLIC LEAGUE</span></span><br/>
<span class="toc_entry_chapter" href="#/e9781439636602_c05" title="Link target outside of Sample"><span>5 - RIVER ROUGE</span></span><br/>
<span class="toc_entry_chapter" href="#/e9781439636602_c06" title="Link target outside of Sample"><span>6 - GREAT COACHES</span></span><br/>
<span class="toc_entry_chapter" href="#/e9781439636602_c07" title="Link target outside of Sample"><span>7 - PLAYOFFS, ALL-STARS, AND CHAMPIONSHIPS</span></span><br/></div>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// e9781439636602_toc01.vue?2ea675b5